import styled from "styled-components";
import {
  SIDE_BAR_WIDTH,
  TOP_NAV_HEIGHT,
  MAIN_CONTENT_MIN_HEIGHT
} from "../../constants";

export const StyledSideBar = styled.div`
  height: 100vh;
  min-height: ${MAIN_CONTENT_MIN_HEIGHT};
  width: ${SIDE_BAR_WIDTH};
  min-width: ${SIDE_BAR_WIDTH};
  background: #212130;
  box-shadow: inset -5px 0 10px 0 rgba(0, 0, 0, 0.2);
`;

export const LogoContainer = styled.div`
  height: ${TOP_NAV_HEIGHT};
  display: flex;
  justify-content: center;
  align-items: center;
  // Need to use rgba here because the opacity should only effect the bg not the innerHTML
  background: rgba(42, 42, 60, 0.5);
  color: #6c7285;
  font-weight: 900;
  cursor: pointer;
`;

export const UserSection = styled.div`
  margin: 30px 20px 30px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UserContent = styled.div`
  display: flex;
  align-items: center;
`;

export const Avatar = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 100%;
`;

export const UserInfo = styled.div`
  margin-left: 14px;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
`;

export const UserName = styled.div`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const UserCompany = styled.div`
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.43px;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  color: #ffffff;
  font-family: HelveticaNeue;
  font-size: 12px;
  letter-spacing: 0.39px;
  margin-bottom: 64px;
`;

export const Link = styled.div`
  line-height: 40px;
  padding-left: ${props => (props.isActive ? "17px" : "22px")};
  border-left: ${props => (props.isActive ? "5px solid #606df0" : null)};
  font-weight: ${props => (props.isActive ? "700" : "400")};
  cursor: pointer;
`;

export const LogoutLink = styled.a`
  // Same default styles for a Link
  line-height: 40px;
  padding-left: 22px;
  font-weight: 400;
  cursor: pointer;

  // Extra styles for the download link since it's an anchor element
  color: #ffffff;
  text-decoration: none;
`;

export const ClientSection = styled.div`
  margin-right: 20px;
`;

export const ClientSectionHeader = styled.div`
  display: flex;
  align-items: center;
  color: #ffffff;
  font-family: "MaisonNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.88px;
  margin-bottom: 14px;
  margin-left: 22px;
`;

export const Gradient = styled.div`
  margin-left: 14px;
  height: 1.5px;
  width: 94px;
  background-image: linear-gradient(to right, #fa5a62, #574d9e);
`;

export const ClientList = styled(Links)`
  margin-bottom: 30px;
  // 350px fixed sized of the content above ClientList and 30px is the margin below the ClientList
  height: calc(100vh - 350px - 30px);
  min-height: calc(${MAIN_CONTENT_MIN_HEIGHT} - 350px - 30px);
  overflow: scroll;

  // Hide browser scrollbar
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
`;

export const ClientListItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Client = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 22px;
  border-left: none;
  font-weight: ${props => (props.isActive ? "700" : "400")};
  cursor: auto;
`;

export const ClientName = styled.span`
  width: 100%;
  margin-right: 12px;
  cursor: pointer;
`;

export const SideCaretWrapper = styled.div`
  transform: ${props => (props.open ? "rotate(180deg)" : null)};
  cursor: pointer;
`;

export const Feed = styled(Link)`
  display: ${props => (props.open ? "flex" : "none")};
  align-items: center;

  svg {
    margin-right: 8px;
  }
`;

export const EmptyFeed = styled(Feed)`
  cursor: auto;

  svg {
    width: 21px;
    height: 21px;
  }
`;
